module.exports = __webpack_public_path__ + "static/img/weixincode.73c568ec.png";